<template>
  <div class="my-0 mx-auto relative w-full max-w-full overflow-x-hidden">
    <div class="min-h-0 box-border pt-3 w-full my-0 mx-auto">
      <div class="relative mx-2 sm:mx-4">
        <div v-if="items.length > 0">
          <WorkshopResponseComponent
            v-for="(workshop, index) in items"
            :key="index"
            :workshop="workshop" />
        </div>
        <div v-else class="py-6">
          <no-workshop-component />
        </div>
      </div>
    </div>
  </div>
  <ProvideFeedbackComponent />
</template>
<script>
import WorkshopResponseComponent from '@/components/Home/WorkshopComponent/WorkshopResponseComponent.vue';
import NoWorkshopComponent from './NoWorkshopComponent.vue';
import ProvideFeedbackComponent from '@/components/global/ProvideFeedbackComponent.vue';

export default {
  name: 'WorkshopComponent',
  props: [],
  components: {
    WorkshopResponseComponent, NoWorkshopComponent, ProvideFeedbackComponent,
  },
  data() {
    return {
    };
  },
  computed: {
    items() {
      return this.$store.getters.currentWorkshopItems;
    },
  },
  mounted() {
    this.$store.dispatch('getListWorkshop');
  },
};
</script>
